// extracted by mini-css-extract-plugin
module.exports = {"active":"_10O7z6glrRWmSXlC986EXI","innactive":"_3W1FNprWuh_Gpr4uyWdlrG","pageItem":"_20xB2YAMBxFLhrPZ1n7K74","paginationEllipsis":"_21-WmLXt-4S7Ijjqq-r_nd"};